import { render, staticRenderFns } from "./A4ATestCard.vue?vue&type=template&id=ad8e1ace&scoped=true"
import script from "./A4ATestCard.vue?vue&type=script&lang=js"
export * from "./A4ATestCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad8e1ace",
  null
  
)

export default component.exports